import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { timer } from 'rxjs/observable/timer';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { stringify } from 'querystring';


declare var $: any;

@Component({
  selector: 'app-customer-da-data',
  templateUrl: './customer-da-data.component.html',
  styleUrls: ['./customer-da-data.component.scss']
})
export class CustomerDaDataComponent implements OnInit {

  form: FormGroup;
  submitted = false;

  contactId = "";
  contact: any = {};
  idNo = "";
  getDAList: any = {};

  displayStyle = "none";

  idnonmasking = "";
  emailnonmasking = "";
  telnonmasking = "";
  mobilenomasking = "";
  accnomasking = "";
  
  accnomaskingAll = "";
  accmaskingAll = "";

  idmasking = "";
  emailmasking = "";
  telmasking = "";
  mobilemasking = "";
  accmasking = "";

  authorize_user = "";
  authorize_password = "";

  get formControl() {
    return this.form.controls;
  }

  constructor(private apiService: ApiService,
    private util: UtilService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute) 
    { 
      this.form = this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
      });
    }

  async ngOnInit() {
  }

  async initData() {
    this.contact = await this.getContact();
    this.idNo = this.contact.dpa_idcard;

    this.getDAList = await this.getDA();
    //console.log(this.getDAList)
    if(this.getDAList != null &&  this.idNo != null )
    { 
      this.maskingid(this.idNo,4);
      this.maskingTelephone(this.getDAList.Telephone,5);
      this.maskingMobile(this.getDAList.MobileNumber,5);
      this.maskingEmail(this.getDAList.EmailAddress,2);
      this.maskingAccount(this.getDAList.AccountList,4);
    }
  }


  async init(id: string) {

    this.contactId = id;
    //this.idNo = "1100000000031";
    await this.initData();
  }

  async getContact() {
    let para = "contactid=" + this.contactId
    let tmp: any = await this.apiService.get("crmservice", "contact", para)
    return tmp[0]
  }

  async getDA() {
    let para = "idNo=" + this.idNo
    let tmp: any = await this.apiService.get("crmservice", "getDA", para);

    return tmp;
  }

  displayPopup() {

    this.form.controls["username"].setValue("");
    this.form.controls["password"].setValue("");

    this.displayStyle = "block";
  }

  close() {
    this.displayStyle = "none";
  }

  async authorize() {

    try {
      this.submitted = true
      if(this.form.valid){
        this.util.ShowWaiting(true)
        let res:any = await this.apiService.post("crmservice", "callcenterLogin", this.form.value)
        if (this.util.isSuccessResponse(res)) {
          if(res.RESCODE == "0" && res.RESMSG == "SUCCESS"){
            let user: any = await this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)

            if(user[0].statuscode == 1)
            {
              let roleList: any = await this.apiService.get("master", "customwebrole");
              let role = roleList.filter((r:any)=>{
              return r.dpa_customwebroleid == user[0].dpa_roleid
              });

              //console.log(role[0].dpa_name);

              if(role[0].dpa_name.indexOf("Supervisor") == -1)//Agent
              {
                this.util.WarningDialog("ไม่ได้รับอนุญาตให้ดูข้อมูลเพิ่มเติม");
              }
              else
              {
                  this.idmasking = this.idnonmasking;
                  this.emailmasking = this.emailnonmasking;
                  this.telmasking = this.telnonmasking;
                  this.mobilemasking = this.mobilenomasking;
                  this.accmaskingAll = this.accnomaskingAll;

                  this.displayStyle = "none";
              }
              

            }
            else{
              this.util.WarningDialog("ไม่ได้รับอนุญาตให้ดูข้อมูลเพิ่มเติม");
            }

            this.util.ShowWaiting(false)

          }
          else{
            this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
          }
        }
        else{
          this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
        }
      }

      this.util.ShowWaiting(false)

    } catch (ex) {
      this.util.ShowWaiting(false);
      this.util.ErrorDialog(ex);
    }
  }

  maskingid(refid: string, digittoshow: number)
  {
    if(refid != null && refid != "" && refid != "N/A")
    {
    let idnonmask = refid.substring(0,digittoshow);
    let digitidmask = 5;
    let domainnonmask = refid.substring(9,refid.length);

    let xmark = "";
    for (let i = 0; i < digitidmask; i++) {
      xmark = xmark + "x";
    }

    this.idnonmasking = refid;
    this.idmasking = idnonmask + xmark + domainnonmask;
  }
  else
  { 
    this.idnonmasking = refid;
    this.idmasking = refid;
  }

  }

  maskingEmail(email: string, digittoshow: number)
  {
    if(email != null && email != "" && email != "N/A")
    {
      let digitofmail = email.indexOf("@");
      let emailnonmask = email.substring(0,digittoshow);
      let digitemailmask = email.substring(digittoshow,digitofmail).length;
      let domainnonmask = email.substring(digitofmail,email.length);

      let xmark = "";
      for (let i = 0; i < digitemailmask; i++) {
        xmark = xmark + "x";
      }

      this.emailnonmasking = email;
      this.emailmasking = emailnonmask + xmark + domainnonmask;
    }
    else{
      
      this.emailnonmasking = email;
      this.emailmasking = email;
    }

  }

  maskingTelephone(tel: string, digittomask: number)
  {
    if(tel != null && tel != "" && tel != "N/A")
    {
    let telonmask = tel.substring(digittomask,tel.length);

    let xmark = "";
    for (let i = 0; i < digittomask; i++) {
      xmark = xmark + "x";
    }

    this.telnonmasking = tel;
    this.telmasking = xmark + telonmask;
    }
    else{
      this.telnonmasking = tel;
      this.telmasking = tel;
    }

  }

  maskingAccount(acc: any, digittomask: number)
  { 
    let accnomasking = "";
    let accmasking = "";
    let nomarkall = "";
    let maskinall = "";
    if(acc !== undefined)
    {
      if(acc.length > 0)
      {

        for(let j = 0; j < acc.length; j++ )
        {
          accnomasking = "";
          accmasking = "";
            if(acc[j].AccountNumber != null && acc[j].AccountNumber != "" && acc[j].AccountNumber !="N/A")
            {
              let mark = acc[j].AccountNumber.length - digittomask;
              let telonmask = acc[j].AccountNumber.substring(mark,acc[j].AccountNumber.length);

            let xmark = "";
            for (let i = 0; i < mark; i++) {
              xmark = xmark + "x";
            }

            accnomasking  = acc[j].AccountNumber;
            accmasking = xmark + telonmask;
          }
          else{
            accnomasking  = acc[j].AccountNumber;
            accmasking = acc[j].AccountNumber;
          }   
            nomarkall = nomarkall + accnomasking + "\n";
            maskinall = maskinall + accmasking + "\n" ;
        }
      }
    }
    this.accmaskingAll = maskinall;
    this.accnomaskingAll = nomarkall;

  }

  maskingMobile(refmobile: string, digittomask: number)
  {
    if(refmobile != null && refmobile != "" && refmobile != "N/A")
    {
      let mobilemask = refmobile.substring(digittomask,refmobile.length);

      let xmark = "";
      for (let i = 0; i < digittomask; i++) {
        xmark = xmark + "x";
      }

      this.mobilenomasking = refmobile;
      this.mobilemasking = xmark + mobilemask;
    } 
    else{
      this.mobilenomasking = refmobile;
      this.mobilemasking = refmobile;
      
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/customer-da-data/customer-da-data.component.ts